<div class="resultBox" *ngIf="match" [class.no-hover]="desactivarHover" (mouseenter)="!desactivarHover && hovering = true" (mouseleave)="!desactivarHover && hovering = false">
    <div class="team-info">
        <img class="team-img" [class.animate-logo]="animate" [src]="match.for?.team?.imgUrl">
        <span class="team-name" [class.animate-out]="animate">{{match.for?.team?.name}}</span>
    </div>
    <div class="result" [class.blink-result]="animate">
        <h2>{{ hovering ? 'Ver Match Center' : match.result }}</h2>
    </div>
    <div class="team-info away">
        <span class="team-name" [class.animate-out]="animate">{{match.against?.team?.name}}</span>
        <img class="team-img" [class.animate-logo]="animate" [src]="match.against?.team?.imgUrl">
    </div>
</div>